import React, { useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

function randomOperand() {
  return 1 + Math.floor(Math.random() * 9);
}

function Contact() {
  const { t } = useTranslation();

  const [replyTo, setReplyTo] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [answer, setAnswer] = useState('');
  const [challenge, setChallenge] = useState(() => ({ a: randomOperand(), b: randomOperand() }));
  const [status, setStatus] = useState('idle'); // idle | sending | sent | error
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    setError('');
    try {
      await axios.post('/api/contact', {
        replyTo,
        subject,
        message,
        num1: challenge.a,
        num2: challenge.b,
        answer,
      });
      setStatus('sent');
      setReplyTo('');
      setSubject('');
      setMessage('');
      setAnswer('');
    } catch (err) {
      setStatus('error');
      setError(err.response?.data?.error || t('contact.genericError'));
      setChallenge({ a: randomOperand(), b: randomOperand() });
      setAnswer('');
    }
  };

  const inputClass = 'w-full px-4 py-2.5 rounded-lg border border-slate-300 bg-white text-slate-800 focus:outline-none focus:ring-2 focus:ring-slate-500';

  if (status === 'sent') {
    return (
      <div className="text-center py-8">
        <h1 className="text-3xl font-bold mb-4 text-slate-900">{t('contact.heading')}</h1>
        <p className="text-lg text-slate-700">{t('contact.sent')}</p>
      </div>
    );
  }

  return (
    <div>
      <h1 className="text-3xl font-bold mb-3 text-center text-slate-900">{t('contact.heading')}</h1>
      <p className="text-slate-600 text-center mb-8 max-w-lg mx-auto">{t('contact.body')}</p>

      <form onSubmit={handleSubmit} className="max-w-lg mx-auto space-y-4">
        <div>
          <label htmlFor="replyTo" className="block text-sm font-medium text-slate-700 mb-1">{t('contact.replyTo')}</label>
          <input
            id="replyTo"
            type="email"
            required
            value={replyTo}
            onChange={e => setReplyTo(e.target.value)}
            className={inputClass}
          />
        </div>

        <div>
          <label htmlFor="subject" className="block text-sm font-medium text-slate-700 mb-1">{t('contact.subject')}</label>
          <input
            id="subject"
            type="text"
            required
            maxLength={200}
            value={subject}
            onChange={e => setSubject(e.target.value)}
            className={inputClass}
          />
        </div>

        <div>
          <label htmlFor="message" className="block text-sm font-medium text-slate-700 mb-1">{t('contact.message')}</label>
          <textarea
            id="message"
            required
            rows={6}
            maxLength={5000}
            value={message}
            onChange={e => setMessage(e.target.value)}
            className={inputClass}
          />
        </div>

        <div>
          <label htmlFor="captcha" className="block text-sm font-medium text-slate-700 mb-1">
            {t('contact.captcha', { a: challenge.a, b: challenge.b })}
          </label>
          <input
            id="captcha"
            type="number"
            required
            value={answer}
            onChange={e => setAnswer(e.target.value)}
            className={`${inputClass} max-w-[140px]`}
          />
        </div>

        {status === 'error' && (
          <p className="text-red-600 text-sm">{error}</p>
        )}

        <button
          type="submit"
          disabled={status === 'sending'}
          className="w-full px-6 py-3 bg-slate-800 text-white font-semibold rounded-lg shadow-md hover:bg-slate-700 disabled:opacity-50 transition-colors"
        >
          {status === 'sending' ? t('contact.sending') : t('contact.submit')}
        </button>
      </form>
    </div>
  );
}

export default Contact;
